// removed by extract-text-webpack-plugin
module.exports = {"root":"_5YkAkK8ahBkFayU8ApKx1","placeholder":"_1w9sveH1MbtCV_0yYwP43N","placeholder-label":"_2xVmKU9Lj01WhKjxm2IO-g","list-wrapper":"F_DzH6Ms5EDgBUDYnhD3i","muhimma":"_1S4hdoXq_QnbwG-7qzO6kL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/dropdown.scss
// module id = 1278
// module chunks = 0